var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"container"}},[_c('dragTreeTable',{ref:"table",staticClass:"treeTable",attrs:{"data":_vm.treeData,"onDrag":_vm.onTreeDataChange,"fixed":"","isdraggable":true}}),_vm._v(" "),_c('ContextMenu',{ref:"editDialog",attrs:{"onMenu":_vm.onMenu}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5059cf60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/system-manage/treeTable/DragTreeTable.vue
// module id = null
// module chunks = 